import React from 'react';
// CheckThick exists only in the frozen legacy web icon set (no @griply/assets equivalent yet).
import { CheckThick } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './setup-checklist-checkbox.style';

export type SetupChecklistCheckboxProps = {
  checked: boolean;
};

// Not the shared ui/checkbox: its real <input> would be invalid HTML inside the row's <button>.
export const SetupChecklistCheckbox: React.FC<SetupChecklistCheckboxProps> = ({
  checked,
}) => (
  <Styled.Box $checked={checked}>
    {checked && <Icon icon={CheckThick} />}
  </Styled.Box>
);
